module.exports = __webpack_public_path__ + "img/stage-4.79ff20ab.png";